import React from "react";

import TopAppBar, {
  TopAppBarIcon,
  TopAppBarRow,
  TopAppBarSection,
  TopAppBarTitle
} from "@material/react-top-app-bar";
import MaterialIcon from "@material/react-material-icon";
import IconButton from "@material/react-icon-button";
import Contact from "react-ionicons/lib/MdMail";
import CV from "./CV";
import Github from "react-ionicons/lib/LogoGithub";
import LinkedIn from "react-ionicons/lib/LogoLinkedin";
import { UncontrolledTooltip } from "reactstrap";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

class Header extends React.Component {
  render() {
    const { toggleDrawer, history } = this.props;

    return (
      <TopAppBar fixed>
        <TopAppBarRow>
          <TopAppBarSection align="start">
            <TopAppBarIcon navIcon tabIndex={0}>
              <IconButton onClick={() => history.push("/")}>
                <img
                  width="90%"
                  className="rounded-circle"
                  src={require("../assets/images/bitmojis/bitmoji4.png")}
                  alt="Avatar"
                />
              </IconButton>
            </TopAppBarIcon>
            <TopAppBarTitle>Roman Rieunier</TopAppBarTitle>
          </TopAppBarSection>
          <TopAppBarSection align="end" role="toolbar">
            <TopAppBarIcon actionItem tabIndex={0}>
              <IconButton
                className="d-none d-md-flex"
                target="_blank"
                id="contact-button"
                onClick={() => {
                  history.push("/contact");
                }}
              >
                <Contact color="white" />
                <UncontrolledTooltip placement="bottom" target="contact-button">
                  Get in touch
                </UncontrolledTooltip>
              </IconButton>
            </TopAppBarIcon>
            <TopAppBarIcon actionItem tabIndex={0}>
              <IconButton
                className="d-none d-md-flex"
                href={require(`../assets/cv/${process.env.REACT_APP_RESUME_PATH}`)}
                target="_blank"
                isLink
                id="resume-button"
              >
                <CV height="22px" alt="resume" />
                <UncontrolledTooltip placement="bottom" target="resume-button">
                  Checkout my CV
                </UncontrolledTooltip>
              </IconButton>
            </TopAppBarIcon>
            <TopAppBarIcon actionItem tabIndex={0}>
              <IconButton
                className="d-none d-md-flex"
                href="https://github.com/Moccko"
                target="_blank"
                isLink
                id="github-button"
              >
                <Github color="white" />
                <UncontrolledTooltip placement="bottom" target="github-button">
                  Checkout my GitHub
                </UncontrolledTooltip>
              </IconButton>
            </TopAppBarIcon>
            <TopAppBarIcon actionItem tabIndex={0}>
              <IconButton
                className="d-none d-md-flex"
                href="https://www.linkedin.com/in/roman-rieunier/"
                target="_blank"
                isLink
                id="linkedin-button"
              >
                <LinkedIn color="white" />
                <UncontrolledTooltip
                  placement="bottom"
                  target="linkedin-button"
                >
                  Let's connect on LinkedIn
                </UncontrolledTooltip>
              </IconButton>
            </TopAppBarIcon>
            <TopAppBarIcon actionItem tabIndex={0}>
              <MaterialIcon
                aria-label="toggle drawer"
                icon="menu"
                onClick={toggleDrawer}
              />
            </TopAppBarIcon>
          </TopAppBarSection>
        </TopAppBarRow>
      </TopAppBar>
    );
  }
}

Header.propTypes = {
  toggleDrawer: PropTypes.func.isRequired,
  history: PropTypes.object
};

export default withRouter(Header);
